import React from "react";
import classes from "./DenOverview.module.css";
import MonDetailsLight from "./MonDetailsLight";
import bonusTable from "../../Assets/Data/NestBonus";
import dropTable from "../../Assets/Data/NestDrops";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router";
import {getNest, minRank} from "../../Util/NestUtil";;

const DenDetail = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);
    const { id } = useParams();
    const nestDetails = [getNest(0, id-1), getNest(1, id-1)];

    if (!nestDetails[0]) {
        return <div className={classes.Error}>Event Not Found</div>
    }
    return (
        <>
        <h1>{t("Nest")} {id}</h1>
         <div className={classes.Wrapper}>
            <h2>{t("GAMESWORD")}</h2>
            <div className={classes.MonWrapper}>
                {
                    nestDetails[0].reduce((prev, cur) => {
                        if(minRank(cur) >= 0) {
                            return prev.concat(cur);
                        }
                        return prev;
                    }, []).map((v, idx) => <MonDetailsLight data={v} key={idx} drops={dropTable.Tables} bonus={bonusTable.Tables} />)
                }
            </div>
         </div>
         <div className={classes.Wrapper}>
            <h2>{t("GAMESHIELD")}</h2>
            <div className={classes.MonWrapper}>
            {
                    nestDetails[1].reduce((prev, cur) => {
                        if(minRank(cur) >= 0) {
                            return prev.concat(cur);
                        }
                        return prev;
                    }, []).map((v, idx) => <MonDetailsLight data={v} key={idx} drops={dropTable.Tables} bonus={bonusTable.Tables} />)
                }
            </div>
         </div>
        </>
        );
};

export default DenDetail;